import { IPaymentFileError } from './payment-file-error.model';
import { IPaymentDocumentFile } from './payment-document-file.model';

export interface IPaymentUploadDataStatus {
    uploadProgress: {
        executed: number;
        total: number
    };
    documents: IPaymentDocumentFile[];
    failed: number;
    succeed: number;
    errors: IPaymentFileError[];
    errorCode: PaymentUploadErrorCode;
    wrongTemplate: IPaymentDocumentFile[];
    emptyFile: IPaymentDocumentFile[];
    invalidCurrencyErrors: IPaymentFileError[];
}

export enum PaymentUploadErrorCode {
    NONE = 'NONE',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
}
